export const apiName: string = 'formas-controles';



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/formas-controle/shared/data.service.ts
 **/